import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]

import { onMounted } from "vue";
import { useFavoritesStore } from "@/services/favorites.store";
import "@/assets/css/icon-moon.css";
import "@/assets/css/app.css";
import "@/assets/css/flower-theme.css";

const WA_NUMBER = "905497786469";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const favoritesStore = useFavoritesStore();
onMounted(() => {
  favoritesStore.fetchFavoriteIds();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _createElementVNode("a", {
      href: `https://wa.me/${WA_NUMBER}?text=Merhaba, sipariş hakkında bilgi almak istiyorum.`,
      target: "_blank",
      rel: "noopener",
      class: "wa-float",
      "aria-label": "WhatsApp ile iletişime geç"
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("svg", {
        width: "28",
        height: "28",
        viewBox: "0 0 24 24",
        fill: "currentColor"
      }, [
        _createElementVNode("path", { d: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" }),
        _createElementVNode("path", { d: "M12 0C5.373 0 0 5.373 0 12c0 2.136.561 4.14 1.535 5.874L.057 23.858a.5.5 0 0 0 .614.614l6.033-1.483A11.943 11.943 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.97 0-3.81-.563-5.37-1.535l-.386-.232-3.989.98.999-3.912-.254-.402A9.944 9.944 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" })
      ], -1)
    ]))], 8, _hoisted_1)
  ], 64))
}
}

})